import { sendTo, setup } from 'xstate';

import type { StateActions, StateActors, StateChildren, StateContext, StateEvents, StateGuards } from './types';

export const machine = setup({
	/* oxlint-disable typescript/no-unsafe-type-assertion */
	types: {
		context: {} as StateContext,
		events: {} as StateEvents,
		children: {} as StateChildren,
	},
	actions: {} as StateActions,
	guards: {} as StateGuards,
	actors: {} as StateActors,
	/* oxlint-enable typescript/no-unsafe-type-assertion */
}).createMachine({
	id: 'start-a-petition',
	initial: 'idle',
	context: ({ input }) => ({ ...input }),
	on: {
		sync_draft: {
			actions: ['syncDraft'],
		},
	},
	states: {
		idle: {
			always: [
				// place all variants before control, as control is the default fallback
				{ target: 'recommendations', guard: 'isVariant' },
				{ target: 'editVariantA', guard: 'isEditVariantA' },
				{ target: 'editVariantB', guard: 'isEditVariantB' },
				// if no guards match, fallback to control
				{ target: 'control' },
			],
		},

		control: {
			invoke: {
				id: 'controlActorId',
				src: 'controlActorSrc',
				input: (input) => input.context,
			},
			on: {
				submit: {
					actions: sendTo('controlActorId', ({ event }) => event),
				},
				back: {
					actions: sendTo('controlActorId', ({ event }) => event),
				},
				error: {
					actions: sendTo('controlActorId', ({ event }) => event),
				},
			},
		},

		recommendations: {
			invoke: {
				id: 'recommendationsActorId',
				src: 'recommendationsActorSrc',
				input: (input) => input.context,
			},
			on: {
				submit: {
					actions: sendTo('recommendationsActorId', ({ event }) => event),
				},
				back: {
					actions: sendTo('recommendationsActorId', ({ event }) => event),
				},
				error: {
					actions: sendTo('recommendationsActorId', ({ event }) => event),
				},
			},
		},

		editVariantA: {
			invoke: {
				id: 'editVariantAActorId',
				src: 'editVariantAActorSrc',
				input: (input) => input.context,
			},
			on: {
				submit: {
					actions: sendTo('editVariantAActorId', ({ event }) => event),
				},
				back: {
					actions: sendTo('editVariantAActorId', ({ event }) => event),
				},
				error: {
					actions: sendTo('editVariantAActorId', ({ event }) => event),
				},
			},
		},

		editVariantB: {
			invoke: {
				id: 'editVariantBActorId',
				src: 'editVariantBActorSrc',
				input: (input) => input.context,
			},
			on: {
				submit: {
					actions: sendTo('editVariantBActorId', ({ event }) => event),
				},
				back: {
					actions: sendTo('editVariantBActorId', ({ event }) => event),
				},
				error: {
					actions: sendTo('editVariantBActorId', ({ event }) => event),
				},
			},
		},
	},
});
